<template>
  <div class="period-college-container">
    <!-- Loading State -->
    <v-fade-transition>
      <div v-if="loading" class="text-center py-12">
        <v-progress-circular
          indeterminate
          color="primary"
          :width="4"
          :size="60"
        />
        <p class="mt-4 text-body1">กำลังโหลดข้อมูล...</p>
      </div>

      <!-- Main Content -->
      <div v-else>
        <!-- Info Header Card -->
        <v-card class="elevation-2 mb-6" style="border-radius: 12px">
          <v-card-text class="pa-6">
            <v-row align="center">
              <v-col cols="auto">
                <div class="edit-button">
                  <v-btn
                    fab
                    small
                    color="warning"
                    @click="period_collegeEdit()"
                    elevation="4"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col>
                <h3 class=" font-weight-bold mb-0">
                  <v-icon small class="mr-2">mdi-calendar-check</v-icon>
                  ข้อมูลกำหนดการปฏิทิน
                </h3>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Info Grid -->
        <v-row class="mb-6">
          <!-- Period Info -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #FF9800"
            >
              <v-card-text class="pa-6">
                <div class="d-flex justify-space-between align-center mb-4">
                  <span class=" font-weight-bold text-grey">
                    ครั้งที่
                  </span>
                  <v-chip
                    color="warning"
                    text-color="white"
                    label
                    small
                  >
                    {{ period_colleges.period_college_times }}
                  </v-chip>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <span class=" font-weight-bold text-grey">
                    ปีการศึกษา
                  </span>
                  <span class=" font-weight-bold text-warning">
                    {{ period_colleges.period_college_year }}
                  </span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Date Range Info -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #2196F3"
            >
              <v-card-text class="pa-6">
                <div class="mb-4">
                  <p class=" font-weight-bold text-grey mb-1">
                    <v-icon x-small class="mr-1">mdi-calendar-start</v-icon>
                    เริ่มวันที่
                  </p>
                  <p class="text-body2 font-weight-bold text-primary">
                    {{
                      period_colleges.period_college_start
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                </div>
                <div>
                  <p class=" font-weight-bold text-grey mb-1">
                    <v-icon x-small class="mr-1">mdi-calendar-end</v-icon>
                    สิ้นสุดวันที่
                  </p>
                  <p class="text-body2 font-weight-bold text-primary">
                    {{
                      period_colleges.period_college_stop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- File Upload Deadline -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #4CAF50"
            >
              <v-card-text class="pa-6">
                <p class=" font-weight-bold text-grey mb-2">
                  <v-icon x-small class="mr-1">mdi-file-upload</v-icon>
                  วันที่สิ้นสุดแนบไฟล์
                </p>
                <p class=" font-weight-bold text-success">
                  {{
                    period_colleges.period_college_attactmentstop
                      | moment("add", "543 years")
                      | moment("D MMMM YYYY")
                  }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- System Status -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #9C27B0"
            >
              <v-card-text class="pa-6">
                <v-row no-gutters class="align-center">
                  <v-col>
                    <p class=" font-weight-bold text-grey mb-2">
                      <v-icon x-small class="mr-1">mdi-server-network</v-icon>
                      สถานะระบบ
                    </p>
                    <v-chip
                      :color="period_colleges.period_college_enable === '1' ? 'success' : 'error'"
                      text-color="white"
                      label
                      small
                      class="mb-2"
                    >
                      <v-icon small class="mr-1">
                        {{
                          period_colleges.period_college_enable === "1"
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      {{ period_colleges.period_college_enable === "1" ? "เปิด" : "ปิด" }}
                    </v-chip>
                  </v-col>
                  <v-col>
                    <p class=" font-weight-bold text-grey mb-2">
                      <v-icon x-small class="mr-1">mdi-file</v-icon>
                      สถานะแนบไฟล์
                    </p>
                    <v-chip
                      :color="period_colleges.period_college_enable_file === '1' ? 'success' : 'error'"
                      text-color="white"
                      label
                      small
                    >
                      <v-icon small class="mr-1">
                        {{
                          period_colleges.period_college_enable_file === "1"
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      {{ period_colleges.period_college_enable_file === "1" ? "เปิด" : "ปิด" }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Status Timeline -->
        <v-card class="elevation-1" style="border-radius: 12px">
          <v-card-title class="pb-4">
            <v-icon small class="mr-2">mdi-timeline</v-icon>
            ลำดับเวลาสำคัญ
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-6">
            <v-timeline align-top>
              <v-timeline-item
                :icon="`mdi-numeric-${period_colleges.period_college_times}-circle`"
                color="warning"
                large
              >
                <div class="mb-2">
                  <h4 class=" font-weight-bold">ครั้งที่ {{ period_colleges.period_college_times }} ปี {{ period_colleges.period_college_year }}</h4>
                  <p class=" text-grey">เป็นช่วงการศึกษา</p>
                </div>
              </v-timeline-item>

              <v-timeline-item
                icon="mdi-calendar-start"
                color="info"
                large
              >
                <div class="mb-2">
                  <h4 class=" font-weight-bold">เริ่มต้นการรายงาน</h4>
                  <p class="text-body2 font-weight-bold">
                    {{
                      period_colleges.period_college_start
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                  <p class=" text-grey">วันเริ่มต้นการรายงานข้อมูล</p>
                </div>
              </v-timeline-item>

              <v-timeline-item
                icon="mdi-calendar-end"
                color="primary"
                large
              >
                <div class="mb-2">
                  <h4 class=" font-weight-bold">ปิดการรายงาน</h4>
                  <p class="text-body2 font-weight-bold">
                    {{
                      period_colleges.period_college_stop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                  <p class=" text-grey">วันสิ้นสุดการรายงานข้อมูล</p>
                </div>
              </v-timeline-item>

              <v-timeline-item
                icon="mdi-file-upload"
                color="success"
                large
              >
                <div class="mb-2">
                  <h4 class=" font-weight-bold">ปิดการแนบไฟล์</h4>
                  <p class="text-body2 font-weight-bold">
                    {{
                      period_colleges.period_college_attactmentstop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                  <p class=" text-grey">วันสิ้นสุดการแนบไฟล์อักษรรับรอง</p>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </div>
    </v-fade-transition>

    <!-- Edit Dialog -->
    <v-dialog
      v-model="editperiod_collegedialog"
      persistent
      max-width="800px"
      scrollable
    >
      <v-card class="elevation-8" style="border-radius: 12px">
        <v-toolbar dark color="warning" rounded>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title class="ml-2">แก้ไขกำหนดการปฏิทิน</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="editperiod_collegedialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-8">
          <v-form ref="editperiod_collegeform" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="editperiod_college.period_college_year"
                  :items="period_collegeselect"
                  item-text="text"
                  item-value="value"
                  label="ปีการศึกษา"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-calendar"
                  :rules="[v => !!v || 'ต้องระบุปีการศึกษา']"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="editperiod_college.period_college_times"
                  type="number"
                  label="ครั้งที่"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-counter"
                  min="1"
                  max="3"
                  :rules="[
                    v => !!v || 'ต้องระบุครั้งที่',
                    v => v >= 1 && v <= 3 || 'ครั้งที่ต้องอยู่ระหว่าง 1-3'
                  ]"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editperiod_college.period_college_start"
                  type="date"
                  label="วันที่เริ่ม"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-calendar-start"
                  :rules="[v => !!v || 'ต้องระบุวันที่เริ่ม']"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editperiod_college.period_college_stop"
                  type="date"
                  label="วันที่สิ้นสุด"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-calendar-end"
                  :rules="[v => !!v || 'ต้องระบุวันที่สิ้นสุด']"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editperiod_college.period_college_attactmentstop"
                  type="date"
                  label="สิ้นสุดแนบไฟล์"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-file-upload"
                  :rules="[v => !!v || 'ต้องระบุวันที่สิ้นสุดแนบไฟล์']"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-switch
                  v-model="editperiod_college.period_college_enable_sw"
                  label="เปิดใช้งานรายงาน"
                  class="mt-0"
                />
                <p class=" text-grey mt-2">
                  <v-icon x-small>mdi-information</v-icon>
                  เปิดจะทำให้สถานศึกษาสามารถรายงานข้อมูลได้
                </p>
              </v-col>

              <v-col cols="12" md="6">
                <v-switch
                  v-model="editperiod_college.period_college_enable_file_sw"
                  label="เปิดใช้งานแนบไฟล์"
                  class="mt-0"
                />
                <p class=" text-grey mt-2">
                  <v-icon x-small>mdi-information</v-icon>
                  เปิดจะทำให้สถานศึกษาสามารถแนบไฟล์ได้
                </p>
              </v-col>
            </v-row>

            <v-alert
              type="info"
              outlined
              rounded
              class="mt-6 mb-0"
              dense
            >
              <strong>หมายเหตุ:</strong> หลังจากบันทึกการเปลี่ยนแปลง ระบบจะส่งการแจ้งเตือนไปยัง Line
              Notify ของสถานศึกษา
            </v-alert>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn
            color="default"
            outlined
            rounded
            @click="editperiod_collegedialog = false"
          >
            <v-icon small class="mr-1">mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="warning"
            rounded
            @click="editperiod_collegeSubmit()"
            :loading="isSubmitting"
          >
            <v-icon small class="mr-1">mdi-check</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
      rounded
    >
      <v-icon small class="mr-2">
        {{
          snackbar.color === "success" ? "mdi-check-circle" : "mdi-alert-circle"
        }}
      </v-icon>
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import VueMoment from "vue-moment";
import moment from "moment-timezone";

export default {
  name: "PeriodCollegeGovernmentId",

  props: {
    period_college_id: {
      type: String,
    }
  },

  data() {
    return {
      VueMoment,
      moment,
      loading: true,
      isSubmitting: false,
      ApiKey: "HRvec2021",
      valid: true,
      editperiod_collegedialog: false,
      snackbar: {
        show: false,
        color: "success",
        timeout: 4000,
        text: ""
      },
      period_colleges: {
        period_college_times: "",
        period_college_year: "",
        period_college_start: "",
        period_college_stop: "",
        period_college_attactmentstop: "",
        period_college_enable: "1",
        period_college_enable_file: "1"
      },
      editperiod_college: {},
      period_collegeselect: [
        { value: "2564", text: "2564" },
        { value: "2565", text: "2565" },
        { value: "2566", text: "2566" },
        { value: "2567", text: "2567" },
        { value: "2568", text: "2568" },
        { value: "2569", text: "2569" },
        { value: "2570", text: "2570" }
      ],
      data_syslog: {},
      line_topic: ""
    };
  },

  computed: {
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");
      return dd + "/" + mm + "/" + yyyy + " " + time;
    }
  },

  async mounted() {
    await this.period_collegeQueryAll();
  },

  methods: {
    async period_collegeQueryAll() {
      try {
        this.loading = true;
        const result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: this.period_college_id
        });
        this.period_colleges = result.data || {};
      } catch (error) {
        console.error("Error loading period college:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูลได้", "error");
      } finally {
        this.loading = false;
      }
    },

    async period_collegeEdit() {
      try {
        const result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: this.period_college_id
        });

        this.editperiod_college = JSON.parse(JSON.stringify(result.data));

        this.editperiod_college.period_college_enable_sw =
          this.editperiod_college.period_college_enable === "1";

        this.editperiod_college.period_college_enable_file_sw =
          this.editperiod_college.period_college_enable_file === "1";

        this.editperiod_collegedialog = true;
      } catch (error) {
        console.error("Error loading edit data:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูลสำหรับแก้ไข", "error");
      }
    },

    async topics_data() {
      const topicMap = {
        teacher_request: "สถานศึกษารวบรวมคำร้องขอย้าย ตำแหน่งครู",
        movement_college: "สถานศึกษาแจ้งเงือนไขการย้าย",
        update_college: "รายงานอัตรากำลัง",
        discuss_college:
          "ขอความเห็นจากคณะกรรมการสถานศึกษาย้ายสายบริหาร",
        discuss_teacher:
          "ขอความเห็นจากคณะกรรมการสถานศึกษาย้าย ตำแหน่งครู",
        reportmove_teacher: "รายงานตัว การย้าย ตำแหน่งครู"
      };
      return topicMap[this.editperiod_college.period_college_type] || "";
    },

    async linenotify(topics, details, datetime_close) {
      try {
        await this.$http.post("linenotify_college.php", {
          ApiKey: this.ApiKey,
          topics: topics,
          details: details,
          datetime_close: datetime_close
        });
      } catch (error) {
        console.error("Error sending line notification:", error);
      }
    },

    async editperiod_collegeSubmit() {
      if (!this.$refs.editperiod_collegeform.validate()) {
        this.showSnackbar("กรุณาตรวจสอบข้อมูลให้ครบถ้วน", "warning");
        return;
      }

      this.isSubmitting = true;

      try {
        if (this.editperiod_college.period_college_enable_sw === true) {
          this.editperiod_college.period_college_enable = "1";
          const timesy =
            this.editperiod_college.period_college_times +
            "/" +
            this.editperiod_college.period_college_year;
          const topic = await this.topics_data();
          await this.linenotify(
            timesy,
            topic,
            this.editperiod_college.period_college_stop
          );
        } else {
          this.editperiod_college.period_college_enable = "0";
        }

        this.editperiod_college.period_college_enable_file =
          this.editperiod_college.period_college_enable_file_sw === true
            ? "1"
            : "0";

        this.editperiod_college.ApiKey = this.ApiKey;

        const result = await this.$http.post(
          "period_college.update.php",
          this.editperiod_college
        );

        if (result.data && result.data.status === true) {
          this.showSnackbar("บันทึกข้อมูลเรียบร้อย", "success");
          this.editperiod_collegedialog = false;

          // Update system log
          let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
          this.data_syslog = {
            ApiKey: this.ApiKey,
            user_account: userSession.user_name || "Unknown",
            event_log: "update",
            page_log: "period_college",
            table_log: "period_college",
            date_times: this.date_today_log
          };

          await this.$http.post("data_syslog.insert.php", this.data_syslog);

          // Reload data
          await this.period_collegeQueryAll();
        } else {
          this.showSnackbar(
            result.data.message || "ดำเนินการผิดพลาด",
            "error"
          );
        }
      } catch (error) {
        console.error("Error submitting edit:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error");
      } finally {
        this.isSubmitting = false;
      }
    },

    showSnackbar(text, color = "success") {
      this.snackbar = {
        show: true,
        text: text,
        color: color,
        timeout: 4000
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.period-college-container {
  width: 100%;
}

.edit-button {
  display: flex;
  justify-content: center;
  align-items: center;

  ::v-deep .v-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: scale(1.1) rotate(5deg);
    }

    &:active {
      transform: scale(0.95);
    }
  }
}

.info-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important;
  }
}

::v-deep {
  .v-timeline {
    &::before {
      background: linear-gradient(
        to bottom,
        rgba(33, 150, 243, 0.3),
        rgba(76, 175, 80, 0.3)
      );
    }
  }

  .v-timeline-item {
    padding-top: 12px;
    padding-bottom: 12px;

    .v-timeline-item__dot {
      border: 3px solid white;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>